// extracted by mini-css-extract-plugin
export default {"option-quantity":"configurator-web-option-quantity","invalid":"configurator-web-invalid","option-name":"configurator-web-option-name"};